import React from "react";
import IntegrationList from "./IntegrationList";
import IntegrationAddButton from "./IntegrationAddButton";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import { connect } from "react-redux";
import ICompany from "../../models/ICompany";
import Services from "../../services/Services";
import IIntegration from "../../models/IIntegration";
import { Grid } from "@material-ui/core";
import IntegrationInfoButton from "./IntegrationInfoButton";
import { NewIntegrationDialog } from "./dialogs/new/NewIntegrationDialog";
import { addPending, completePending } from "../../store/status/actions";

export interface IIntegrationListWithDataProps {
  token: string;
  company?: ICompany;
}

const IntegrationListWithData = (props: IIntegrationListWithDataProps) => {
  const { token, company } = props;

  const [integrations, setIntegrations] = React.useState<Array<IIntegration>>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [quietReload, setQuietReload] = React.useState(false);
  const [stamp, setStamp] = React.useState(new Date());
  const [showAdd, setShowAdd] = React.useState<boolean>(false);

  React.useEffect(() => {
    const getIntegrations = async () => {
      const integrationRepo = await new Services().IntegrationRepository();
      try {
        setIsLoading(true);
        if (company) {
          const resp = await integrationRepo.getByCompany(token, company.ID);
          setIntegrations(resp);
        } else {
          throw new Error("Company is required to see list of integrations");
        }
      } catch (err) {
        snackbarService.error(err);
      }

      setIsLoading(false);
      setQuietReload(false);
    };

    getIntegrations();
  }, [company, stamp]);

  const handleRefresh = () => {
    setQuietReload(true);
    setStamp(new Date());
  };

  return (
    <>
      <WithLoadingSpinners message="Gathering data" isLoading={!quietReload && isLoading}>
        <Grid item xs={12}>
          <NewIntegrationDialog
            showDialog={showAdd}
            onClose={() => setShowAdd(false)}
            token={token}
            company={company}
            addPending={addPending}
            completePending={completePending}
          />
        </Grid>
        <Grid item xs={12}>
          <IntegrationAddButton onClick={() => setShowAdd(true)} />
          <IntegrationInfoButton />
        </Grid>
        <IntegrationList integrations={integrations} onRequestRefresh={() => handleRefresh()} />
      </WithLoadingSpinners>
    </>
  );
};

export default connect((state: IApplicationState) => {
  return {
    authCompanyId: selectAuth(state).companyId,
    ...selectAuth(state),
  };
})(IntegrationListWithData);
